module.exports = __webpack_public_path__ + "img/icon301.54197c75.png";